import React from 'react';
import styles from './AboutSection.module.css';

const AboutSection = () => {
  return (
    <section className={styles.about}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2>Acerca de <span className={styles.highlight}>Megaloto</span></h2>
          <p>
            Megaloto es una plataforma líder que te conecta con los sorteos más emocionantes. Desde la comodidad de tu hogar, puedes participar en 
            sorteos intractivos, ganar increíbles premios, y convertir tus sueños en realidad.
          </p>
          <p>
            Nuestro objetivo es proporcionar una experiencia segura, divertida y accesible
            para todos los amantes de los juegos de azar y sorteos. Con una interfaz intuitiva y 
            soporte al cliente 24/7, nos aseguramos de que tengas la mejor experiencia posible.
          </p>
        </div>
        <div className={styles.image}>
          <img src="https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/empresa%2FlogoMegaLoto.png?alt=media&token=ddc64046-fd7a-459b-9a4f-ebba7b4e8dde" alt="Sobre Megaloto" />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
